export default __webpack_public_path__ + "static/media/Drum_img_01.9fae60e4.png";